export default __webpack_public_path__ + "static/media/img-team-advisros-jg3x.69e87ff6.png";